// Because of JS import hoisting, we need this init code to be here,
// so that following imports in application.js have access to `n2words`

import n2words from 'n2words';
window.n2words = n2words;

